module.exports = __webpack_public_path__ + "img/modelo-pp1.2e32058c.png";